// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3iQ2h","label":"Completed_label__JaBVl"};